import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-activity-reason",
  templateUrl: "./admin-activity-reason.component.html",
  styleUrls: ["./admin-activity-reason.component.css"],
})
export class AdminActivityReasonComponent implements OnInit {
  token: any;
  reasonForm: FormGroup;
  reasonArray: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private matdialogref: MatDialogRef<AdminActivityReasonComponent>,
    private formBuilder: FormBuilder,
    private services: AdminService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.reasonForm = this.formBuilder.group({
      driver_reason: ["", [Validators.required]],
    });
  }
  close() {
    this.matdialogref.close();
  }

  activityReason() {
    this.reasonArray = this.reasonForm.value.driver_reason;
    const reasonObj = {
      driver_remarks: this.reasonForm.value.driver_reason,
    };
    if (reasonObj.driver_remarks == "") {
      this.snackBar.open("Please Enter Reason", "Error", {
        duration: 5000,
      });
      return;
    }

    this.services
      .updateReasonStatus(
        this.token,
        this.data.userStatus,
        this.data.user_data,
        this.data.id,
        reasonObj
      )
      .subscribe(
        (response: any) => {
          if (response.status == 200) {
            if (this.data.user_data == "driver") {
              this.matdialogref.close({ status: "success" });
              location.reload();
              this.snackBar.open("Driver Rejected", "Success", {
                duration: 5000,
              });
            }
            if (this.data.user_data == "truckowner") {
              this.matdialogref.close({ status: "success" });
              location.reload();
              this.snackBar.open("truckowner Rejected", "Success", {
                duration: 5000,
              });
            }
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
}
